import { Inject } from '@angular/core';
import { Router, Scroll } from '@angular/router';
import { environment } from '@env/environment';
import { filter } from 'rxjs/operators';


export class ScrollToLastPosition {
    private positionTop: number = 0;
    constructor(
        @Inject(Router) router: Router) {
        router.events
            .pipe(
                filter((event) => event instanceof Scroll)
            ).subscribe((event: Scroll) => {
                if (event.position)
                    this.positionTop = event.position[1];
            });
    }
    public scrollToPosition() {
        if (environment.debug)
            console.log(`%c scroll in route===>>>>> ${this.positionTop},   scroll in screen: ${scrollY}`, 'background: black; color: cyan; font-size: 18px');
        try {
            scroll({ left: 0, top: this.positionTop });
        } catch (e) {
            scroll(0, this.positionTop);
        }
    }
}